// ハンバーガー
function toggleDrawer() {
  document.querySelector('html').classList.toggle('js-drawer-open');
}

const HAMBURGER = document.querySelector('#hamburger');
HAMBURGER.addEventListener('click', function () {
  toggleDrawer();
});

const DRAWER_NAV_LINK = document.querySelectorAll('.drawer__nav-link, .drawer__button-cta');
DRAWER_NAV_LINK.forEach((item) => {
  item.addEventListener('click', () => {
    toggleDrawer();
  });
});

// 固定ボタン
try {
  const HTML = document.documentElement;
  const SECTION_FV = document.querySelector('.section-fv');
  const SECTION_CONTACT = document.querySelector('.section-form');

  const onScroll = () => {
    if (!SECTION_FV) return;

    const fvBottom = SECTION_FV.getBoundingClientRect().bottom;
    const contactTop = SECTION_CONTACT ? SECTION_CONTACT.getBoundingClientRect().top : Infinity;

    // FVを抜けた && contactに入ってない
    const isShow = fvBottom <= 0 && contactTop > window.innerHeight;

    HTML.classList.toggle('js-intersecting-fv', isShow);
  };

  window.addEventListener('scroll', onScroll);
  window.addEventListener('load', onScroll); // 初期判定
} catch (error) {
  console.log(error);
}

// 見出しフェードインアニメーション
try {
  const HEADING_LIST = document.querySelectorAll('.heading-fadein');

  const OBSERVER_HEADING = new IntersectionObserver((entries) => {
    entries.forEach(
      (entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('js-fadein');
        }
      },
      {
        root: null,
        threshold: 0.3,
      },
    );
  });

  HEADING_LIST.forEach((item) => {
    OBSERVER_HEADING.observe(item);
  });
} catch (error) {
  console.log(error);
}

// 相談事例の紹介
new Swiper('#swiper-case', {
  // スライダーが無限ループするように設定
  slidesPerView: 1,
  loop: true,

  // ページネーション（スライドの位置を示すインジケーター）を設定
  pagination: {
    el: '.swiper-custom-pagination', // ページネーションを表示する要素を指定
    clickable: true, // ページネーションをクリックしてスライドを切り替えることができるようにする
  },

  // ナビゲーションボタンを設定
  navigation: {
    nextEl: '.swiper-custom-button-next', // 「次へ」ボタンを指定
    prevEl: '.swiper-custom-button-prev', // 「前へ」ボタンを指定
  },
});

// スムーズリンク
function smoothScroll(eventTarget) {
  const URL = eventTarget.currentTarget.getAttribute('href').replace('/', '');
  const target = document.querySelector(URL);
  if (!target) return;
  eventTarget.preventDefault();

  const headerHeight = document.querySelector('header').offsetHeight;
  const targetPos = target.getBoundingClientRect().top + window.pageYOffset;

  window.scrollTo({
    top: targetPos - headerHeight,
    behavior: 'smooth',
  });
}

try {
  document.querySelectorAll('a[href*="#"]').forEach((el) => {
    el.addEventListener('click', function (e) {
      smoothScroll(e);
    });
  });
} catch (error) {
  console.log(error);
}

// micromodal
MicroModal.init({
  disableScroll: true,
});

// // 離脱防止用ポップアップ
// // 要素複製
// const POPUP_PREVENT_CHURN = document.querySelector('#popup-prevent-churn');

// const CLONED_POPUP_PREVENT_CHURN = POPUP_PREVENT_CHURN.cloneNode(true);
// CLONED_POPUP_PREVENT_CHURN.classList.add('js-cloned');
// document
//   .querySelector('#micromodal-popup-prevent-churn .micromodal__content')
//   .appendChild(CLONED_POPUP_PREVENT_CHURN);
// if (POPUP_PREVENT_CHURN && window.matchMedia('(max-width:767.8px)').matches) {
//   // 参加者の声までスクロールでポップアップ表示
//   const OBSERVER_VOICE = new IntersectionObserver((entries) => {
//     if (entries[0].isIntersecting) {
//       MicroModal.show('micromodal-popup-prevent-churn');
//       OBSERVER_VOICE.disconnect();
//     }
//   });

//   OBSERVER_VOICE.observe(document.querySelector('#section-voice'));
// }

// CTAボタンにセミナーIDが含まれていたら、フォームの「参加希望セミナー」を入力した状態にする
function setSeminorSelectbox(button) {
  const MICROMODAL_SEMINOR_BUTTON_CTA_CONTACT_SEMINOR_ID_TO_FORM = button.dataset.seminarIdToForm;
  console.log(MICROMODAL_SEMINOR_BUTTON_CTA_CONTACT_SEMINOR_ID_TO_FORM);

  const FORM_SEMINOR_SELECT_LIST = document.querySelector('#form-seminar .form-select');
  const OPTION_LIST = FORM_SEMINOR_SELECT_LIST.querySelectorAll('option');

  if (MICROMODAL_SEMINOR_BUTTON_CTA_CONTACT_SEMINOR_ID_TO_FORM) {
    if (!FORM_SEMINOR_SELECT_LIST.length > 0) {
      return;
    }

    OPTION_LIST.forEach((option) => {
      const SEMINOR_ID = option.dataset.seminarId;

      if (SEMINOR_ID === MICROMODAL_SEMINOR_BUTTON_CTA_CONTACT_SEMINOR_ID_TO_FORM) {
        option.selected = true;
      }
    });
  } else if (MICROMODAL_SEMINOR_BUTTON_CTA_CONTACT_SEMINOR_ID_TO_FORM === undefined) {
    console.log('セミナーIDが設定されていません');
    OPTION_LIST[0].selected = true;
  }
}

try {
  const SEMINOR_INFORMATION_LIST = document.querySelectorAll('[data-seminar-information-item]');
  SEMINOR_INFORMATION_LIST.forEach((item) => {
    // セミナー「無料参加申し込み」ボタン押下時、フォームのセレクトに値を設定
    const ENTRY_BUTTONS = item.querySelectorAll('[data-seminar-information-link]');

    ENTRY_BUTTONS.forEach((ENTRY_BUTTON) => {
      ENTRY_BUTTON.addEventListener('click', function (e) {
        setSeminorSelectbox(e.currentTarget);
      });
    });
  });

  SEMINOR_INFORMATION_LIST.forEach((item) => {
    // 当日日付 > 開催日付の場合は、非表示にする
    const DATE_OPEN = item.querySelector('[data-seminar-information-item-date]');
    const str = DATE_OPEN.textContent; // "2026/03/26(木)" を想定

    // 年月日を抽出
    const [year, month, day] = str.match(/\d+/g);

    const targetDate = new Date(year, month - 1, day);
    const today = new Date();

    // 時刻をリセット（超重要）
    today.setHours(0, 0, 0, 0);
    targetDate.setHours(0, 0, 0, 0);

    // 今日より前なら
    if (targetDate < today) {
      item.remove();
    }
  });

  // 直近セミナー
  const SEMINAR_NEAR_INFORMATION_PC_LIST = document.querySelectorAll('#near-seminar-pc [data-seminar-near-information-item]')
  const SEMINAR_NEAR_INFORMATION_SP_LIST = document.querySelectorAll('#near-seminar-sp [data-seminar-near-information-item]')

  // 開催日が近い順に並べ替え、直近3件だけ残して以降は非表示にする

  function FilterNearSeminarInformation(list) {
    list.forEach(( item, index ) => {
      if(index > 2) {
        item.remove()
      }
    });
  }
  FilterNearSeminarInformation(SEMINAR_NEAR_INFORMATION_PC_LIST)
  FilterNearSeminarInformation(SEMINAR_NEAR_INFORMATION_SP_LIST)

  // 2026.05.13
// 直近のセミナー日程
const swiperWrapperList = document.querySelectorAll('.swiper-wrapper');
swiperWrapperList.forEach((wrapper) => {
  const slides = wrapper.querySelectorAll('.swiper-slide');

  // 3枚以下なら複製
  if (slides.length <= 3) {
    slides.forEach((slide) => {
      wrapper.appendChild(slide.cloneNode(true));
    });
  }
});

new Swiper('#near-seminar-sp', {
  // スライダーが無限ループするように設定
  loop: true, // ループ
  speed: 1500, // 少しゆっくり(デフォルトは300)
  slidesPerView: 1.2,
  loop: true,
  spaceBetween: 16, // スライド間の距離
  centeredSlides: true, // アクティブなスライドを中央にする

  autoplay: {
    // 自動再生
    delay: 3000,
    disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
  },

  // ページネーション（スライドの位置を示すインジケーター）を設定
  pagination: {
    el: '.swiper-custom-pagination', // ページネーションを表示する要素を指定
    clickable: true, // ページネーションをクリックしてスライドを切り替えることができるようにする
  },

  // ナビゲーションボタンを設定
  navigation: {
    nextEl: '.swiper-custom-button-next', // 「次へ」ボタンを指定
    prevEl: '.swiper-custom-button-prev', // 「前へ」ボタンを指定
  },

  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    768: {
      slidesPerView: 3,
    },
  },
});
} catch (error) {
  console.log(error);
}

// セミナーポップアップ
// CTA押したらポップを閉じてスクロール
const MICROMODAL_SEMINOR = document.querySelectorAll('.micromodal');
MICROMODAL_SEMINOR.forEach((item) => {
  try {
    const MODAL_ID = item.getAttribute('id');

    const MICROMODAL_SEMINOR_BUTTON_CTA_CONTACT = item.querySelector(
      '[data-micromodal-anchor="true"]',
    );

    MICROMODAL_SEMINOR_BUTTON_CTA_CONTACT.addEventListener('click', (e) => {
      // CTAボタンにセミナーIDが含まれていたら、フォームの「参加希望セミナー」を入力した状態にする
      setSeminorSelectbox(e.currentTarget);

      MicroModal.close(MODAL_ID);
      smoothScroll(e);
    });
  } catch (error) {
    console.log(error);
  }
});

// お問い合わせフォームのタブ切り替え
function toggleTab(tabContainer, TABS, PANELS, tab) {
  // 全てのタブを非アクティブ
  TABS.forEach((itemTab) => itemTab.setAttribute('aria-selected', 'false'));

  // クリックされたタブをアクティブにする
  tab.setAttribute('aria-selected', 'true');

  // 全てのパネルを非表示
  PANELS.forEach((itemPanel) => (itemPanel.hidden = true));

  // 対応するパネルを見つける
  const TARGET_ID = tab.getAttribute('aria-controls');

  if (!TARGET_ID) {
    console.log('aria-controlsが設定されていないタブがあります:', tab);
    return;
  }

  const PANEL = tabContainer.querySelector(`#${TARGET_ID}`);

  if (!PANEL) {
    console.log('対応するパネルが見つかりません', PANEL);
    return;
  }

  PANEL.hidden = false;
}

try {
  const TAB_CONTAINER_LIST = document.querySelectorAll('.tab-container');
  TAB_CONTAINER_LIST.forEach((tabContainer) => {
    const TABS = tabContainer.querySelectorAll('[role="tab"]');
    const PANELS = tabContainer.querySelectorAll('[role="tabpanel"]');

    // タブクリックでフォーム切り替え
    TABS.forEach((tab) => {
      tab.addEventListener('click', () => {
        try {
          toggleTab(tabContainer, TABS, PANELS, tab);
        } catch (error) {
          console.log(error);
        }
      });
    });

    // 無料セミナー申込みポップアップを押下したら、セミナー申しこみフォームを開く
    try {
      const BUTTON_CTA_SEMINOR_SEMINOR = document.querySelectorAll(
        'a[data-form-tab-seminar-selected]',
      );
      BUTTON_CTA_SEMINOR_SEMINOR.forEach((button) => {
        button.addEventListener('click', () => {
          toggleTab(
            tabContainer,
            TABS,
            PANELS,
            tabContainer.querySelector('[aria-controls="form-panel-seminar"]'),
          );
        });
      });
    } catch (error) {
      console.log(error);
    }

    // 問い合わせポップアップを押下したら、問い合わせフォームを開く
    try {
      const BUTTON_CTA_SEMINOR_CONTACT = document.querySelectorAll(
        'a[data-form-tab-contact-selected]',
      );
      BUTTON_CTA_SEMINOR_CONTACT.forEach((button) => {
        button.addEventListener('click', () => {
          toggleTab(
            tabContainer,
            TABS,
            PANELS,
            tabContainer.querySelector('[aria-controls="form-panel-contact"]'),
          );
        });
      });
    } catch (error) {
      console.log(error);
    }
  });
} catch (error) {
  console.log(error);
}

$(window).on('load', function () {
  //<form>タグのidを指定
  $('#form-seminar').validationEngine({
    promptPosition: 'topLeft',
    showArrow: false,
    scroll: false,
    autoPositionUpdate: true,
  });
  $('#form-normal').validationEngine({
    promptPosition: 'topLeft',
    showArrow: false,
    scroll: false,
    autoPositionUpdate: true,
  });
});

try {
  const elements = document.querySelectorAll('.form-input-select-option-seminar');

  elements.forEach((el) => {
    const str = el.textContent;
    // 例: "2026/03/29(日)_激変する大阪..."

    // アンダースコアより前だけ取得
    const datePart = str.split('_')[0];

    // 年月日を抽出
    const [year, month, day] = datePart.match(/\d+/g);

    const targetDate = new Date(year, month - 1, day);
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    targetDate.setHours(0, 0, 0, 0);

    // 過去なら削除
    if (targetDate < today) {
      el.remove();
    }
  });
} catch (error) {
  console.log(error);
}